import config from '../../../config';

const homeContentBaseUrl = `${config.apiUrl}/home_contents`;

export default {
  getHomeContentsUrl: () => homeContentBaseUrl,
  getHomeCharityOytreachesUrl: () => `${homeContentBaseUrl}/home_charity_outreaches`,
};
